import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

//element ui
import i18n from '@/i18n';
import Element from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

Vue.use(Element, { size:'mini'})

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'
import '@/assets/css/common.scss'

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
